<template>
  <v-dialog v-if="showMonadtestFaucet" v-model="computedShowFaucet" max-width="450">
    <v-card outlined class="modal-card" rounded="lg" min-height="300">
      <v-card-title class="d-flex justify-space-between">
        <span>Faucet</span>
        <v-btn @click="close" icon><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider class="my-2" />
      <v-card-text>
        <section>
          <div>Your address</div>
          <h4>{{ account }}</h4>
        </section>
        <section v-if="xAccessed">
          <div class="mt-8">
            <h-captcha
              sitekey="2c1a285a-0dae-41e2-8d3c-c67041dc66ee"
              @verify="onVerify"
              @error="onError"
              @expired="onExpired"
            />
            <v-btn color="accent" class="mt-8" :disabled="false" depressed large block @click="fetchMonadtestEnergyByX(account, state, code)">
              <span>Claim MON</span>
            </v-btn>
          </div>
        </section>
        <section v-else>
          <div v-if="loading" class="d-flex flex-column py-5">
            <div class="d-flex justify-center">
              <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
            </div>
          </div>
          <div v-else>
            <div v-if="errMsg" class="d-flex flex-column justify-center">
              <v-icon color="red" :style="{ fontSize: '150px' }">mdi-close</v-icon>

              <span class="text-center">{{ errMsg }}</span>

              <!-- <v-btn class="mt-8" depressed block color="secondary">Go Sumer.Points</v-btn> -->
            </div>
            <div v-else-if="sucMsg" class="d-flex flex-column justify-center">
              <v-icon color="green" :style="{ fontSize: '150px' }">mdi-check</v-icon>
              <div class="text-center">
                <span>Your address {{ account | short }}  just received 1 TMON in airdrop</span>
                <v-btn icon @click="viewScan"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </div>
            </div>
          </div>
        </section>
        <div class="secondary--text mt-5">
           Tip: Currently each X account can only claim the test token once.  The restricition will be released as we receive more test tokens.
          <!-- <v-btn @click="confirm = true">123</v-btn> -->
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="confirm" max-width="450">
      <v-card outlined rounded="lg">
        <v-card-title class="d-flex justify-space-between">
          <span>Confirm</span>
          <span></span>
        </v-card-title>
        <v-divider class="my-2" />
        <v-card-text>
          <section class="py-4">
            <h3>Connect your X account and follow @SumerMoney.</h3>
          </section>
          <section class="text-center">
            <v-btn class="font-weight-bold" color="primary" @click="confirmJumpX">Confirm</v-btn>
            <v-btn class="ml-2" @click="cancelJumpX">Cancel</v-btn>
          </section>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import { getMonadtestEnergy, getMonadtestEnergyByX } from '../../../api'
import { DEFAULT_ADDRESS } from '../../../constants'
import hCaptcha from '@hcaptcha/vue-hcaptcha';

export default {
  name: 'MonadtestFaucetModal',
  components: {
    hCaptcha
  },
  data() {
    return {
      loading: true,
      errMsg: '',
      sucMsg: '',
      authUrl: '',
      confirm: false,

      xAccessed: false,
      state: '',
      code: '',
      captchaToken: ''
    }
  },
  watch: {
    account(val) {
      if (val !== DEFAULT_ADDRESS) {
        const { state, code } = this.$route.query
        if (state && code) {
          console.log('fetch monadtest energy with x')
          // this.fetchMonadtestEnergyByX(val, state, code)
          this.xAccessed = true
          this.state = state
          this.code = code
          this.open()
        }
      }
    },
    showMonadtestFaucet(val) {
      if (val) {
        const { state, code } = this.$route.query
        if (!(state && code)) {
          console.log('fetch monadtest energy')
          this.fetchMonadtestEnergy(this.account)
        }
      }
    }
  },
  computed: {
    ...mapState('modal', ['showMonadtestFaucet']),
    ...mapState('wallet', ['chainId', 'account']),
    computedShowFaucet: {
      get() {
        return this.showMonadtestFaucet
      },
      set() {
        this.close()
      },
    },
  },
  methods: {
    fetchMonadtestEnergy(address) {
      this.loading = true
      this.errMsg = ''
      this.sucMsg = ''
      console.log('get monadtest energy')
      getMonadtestEnergy(address).then(res => {
        this.loading = false
        console.log('res', res)
        if (res.data.error) {
          this.errMsg = res.data.error
        } else {
          const { authUrl, hash } = res.data.results
          if (authUrl) {
            this.authUrl = authUrl
            this.confirm = true
          } else {
            this.sucMsg = hash
          }
        }
      }).catch(err => {
        this.loading = false
        console.log('err for get monadtest energy', err.message)
        this.errMsg = err.message
      })
    },
    fetchMonadtestEnergyByX(address, state, code) {
      if (!this.captchaToken) {
        alert("Please complete the reCAPTCHA verification!");
        return;
      }
      this.xAccessed = false
      this.loading = true
      this.errMsg = ''
      this.sucMsg = ''
      console.log('get monadtest energy')
      getMonadtestEnergyByX(address, state, code, this.captchaToken).then(res => {
        this.loading = false
        console.log('res', res)
        if (res.data.error) {
          this.errMsg = res.data.error
        } else {
          const { hash } = res.data.results
          if (hash) {
            this.sucMsg = hash
          }
        }

        // remove state and code
        this.$router.replace({
          path: this.$route.path,
          query: { chain: this.$route.query.chain },
        })
      }).catch(err => {
        this.loading = false
        console.log('err for get monadtest energy', err.message)
        this.errMsg = err.message
      })
    },
    open() {
      this.$store.commit('modal/SHOW_MONADTEST_FAUCET')
    },
    close() {
      this.clearData()
      this.$store.commit('modal/HIDE_MONADTEST_FAUCET')
    },
    confirmJumpX() {
      window.open(this.authUrl, '_self')
    },
    cancelJumpX() {
      this.confirm = false
      this.errMsg = 'User Rejected.'
    },
    viewScan() {
      window.open(`https://testnet.monadexplorer.com/tx/${this.sucMsg}`)
    },
    onVerify(token) {
      // console.log("验证成功，Token:", token);
      this.captchaToken = token;
    },
    onError(error) {
      console.error("验证失败:", error);
    },
    onExpired() {
      console.warn("验证已过期，请重新验证");
      this.captchaToken = ''
    },
    clearData() {
      this.xAccessed = false,
      this.state = '',
      this.code = '',
      this.captchaToken = ''
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@/style/_variable.scss';
</style>
